import type { UseMutationOptions } from '@tanstack/react-query';

import queryClient from '../../../ReactQuery/client';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';

import { getUserMasqueradeQueryKey } from './useGetUserMasquerade';

async function maskAsUser(userId: number) {
  return post<{ userId: number }, { userId: number }>('/api/users/masquerade/mask', { userId });
}

type MaskAsUserResponse = Awaited<ReturnType<typeof maskAsUser>>;

type MaskAsUserOptions = Omit<
  UseMutationOptions<MaskAsUserResponse, Error, number>,
  'mutationFn'
>;

/**
 * Mask the super admin as a user.
 */
export default function useMaskAsUser(options?: MaskAsUserOptions) {
  return useToastedMutation({
    mutationFn: (userId: number) => maskAsUser(userId),
    onSuccess: () => {
      // Invalidate the masquerade status query to reflect the new masked user
      queryClient.invalidateQueries({ queryKey: getUserMasqueradeQueryKey });
      window.location.reload();
    },
    successToastMessage: 'Successfully masquerading as user',
    errorToastMessage: 'Failed to masquerade as user',
    ...options,
  });
}
